import { FormChip } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

export const ThemedFormPeerToPeerPrimaryCampaignType = () => {
  const { t } = useTranslate();

  return <FormChip variant="outlined" label={t("donationForm", "peerToPeer.chip.generalCampaign")} />;
};
